/* src/app/job-audit/job-audit-presenter/job-audit-presenter.component.scss */
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-wrapper .p-datatable-scrollable-view .p-datatable-scrollable-header {
  height: 2em;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-tbody td.p-datatable-cell {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
}
/*# sourceMappingURL=job-audit-presenter.component.css.map */
